import { observer } from 'mobx-react';
import { LearningCollectionResource } from '../../../../Types';
import InviteParticipantStore from '../Store';
import InviteModal from './InviteModal';
import ParticipantsInvitedModal from './ParticipantsInvitedModal';
import SelectParticipantsModal from './SelectParticipantsModal';

interface Props {
  store: InviteParticipantStore;
  learningCollectionResource: LearningCollectionResource;
}

function Modal({ store, learningCollectionResource }: Props) {
  switch (store.state.kind) {
    case 'ready':
    case 'new-participant':
    case 'new-group':
    case 'remove-participant':
    case 'remove-group':
    case 'error':
    case 'get-license-information':
      return (
        <SelectParticipantsModal
          modalStore={store.modalStore}
          store={store}
          learningCollectionResource={learningCollectionResource}
          state={store.state}
        />
      );
    case 'participants-invited':
      return (
        <ParticipantsInvitedModal
          store={store}
          successfulCommunicationsCount={store.state.successfulCommunicationsCount}
          sendEmailDate={store.state.sendEmailDate}
          skipCommunications={store.state.skipCommunications}
        />
      );
    case 'submitting':
    case 'inviting':
      return <InviteModal state={store.state} store={store} />;
  }
}

export default observer(Modal);
